export default __webpack_public_path__ + "static/media/Lato-Regular.faacec1c.ttf";